import { helper } from '@ember/component/helper';
import { Task } from 'ember-concurrency/-task-property';

function isTask([obj]) {
  return obj instanceof Task;
}

export default helper(isTask);
